import React from 'react'
import Navbar from '../component/Navbar'
import Sidebar from '../component/Sidebar'

export const MainLayout = (props) => {
    return (
        <div>
            <div>
                <Navbar />
            </div>
            <div className='flex'>
                <div>
                    <Sidebar />
                </div>
                <div className='layout-wrapper'>
                    {props?.children}
                </div>
            </div>

        </div>
    )
}

